import axios, { AxiosResponse } from 'axios'
import { ID } from '../../../../../../_metronic/helpers'
import {
  SetorAsoDtoCreate,
  SetorAsoDtoUpdate,
  SetorAsoView,
  SetoresClienteQueryResponse,
} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const CLIENTE_SETOR_URL = `${API_URL}/empresas/cliente/setor`

/**
 * Busca todos os setores de clientes
 * @param idEmpresa Identificador da empresa pai
 * @param query string
 * @returns SetoresClienteQueryResponse
 */
export const getSetoresCliente = (
  idEmpresa: ID,
  query: string
): Promise<SetoresClienteQueryResponse> => {
  return axios
    .get(`${CLIENTE_SETOR_URL}?idEmpresa=${idEmpresa}&${query}`)
    .then((d: AxiosResponse<SetoresClienteQueryResponse>) => d.data)
}

/**
 * Busca um setor
 * @param idSetor Idetificador do setor
 * @returns SetorAsoView
 */
export const getSetorClienteById = (idSetor: ID): Promise<SetorAsoView> => {
  return axios
    .get(`${CLIENTE_SETOR_URL}/${idSetor}`)
    .then((response: AxiosResponse<SetorAsoView>) => response.data)
}

/**
 * Cadastra um setor do cliente
 * @param idEmpresaCliente Identificador da empresa cliente
 * @param setor Objeto SetorAsoDtoCreate
 * @returns SetorAsoView
 */
export const createSetor = (
  idEmpresaCliente: ID,
  setor: SetorAsoDtoCreate
): Promise<SetorAsoView> => {
  return axios
    .post(`${CLIENTE_SETOR_URL}/${idEmpresaCliente}`, setor)
    .then((resp: AxiosResponse<SetorAsoView>) => resp.data)
}

/**
 * Altera um setor da empresa cliente
 * @param idEmpresaCliente Identificador da empresa cliente
 * @param setor Objeto SetorAsoDtoUpdate
 * @returns SetorAsoView
 */
export const editSetorCliente = (
  idEmpresaCliente: ID,
  setor: SetorAsoDtoUpdate
): Promise<SetorAsoView | undefined> => {
  return axios
    .put(`${CLIENTE_SETOR_URL}/${idEmpresaCliente}`, setor)
    .then((resp: AxiosResponse<SetorAsoView>) => resp.data)
}

/**
 * Remove o setor de um cliente
 * @param idSetor Identificador do setor
 * @returns void
 */
export const deleteSetorCliente = (idSetor: ID): Promise<void> => {
  return axios.delete(`${CLIENTE_SETOR_URL}/${idSetor}`).then(() => {})
}

/**
 * Deleta setores em lote. O backend não tem exclusão em lote: dispara uma requisição por id,
 * em paralelo, e rejeita se qualquer uma falhar.
 * @param setorIds Idetificadores dos setores
 */
export const deleteLoteSetoresCliente = (setorIds: ID[]): Promise<void> => {
  return Promise.all(setorIds.map(deleteSetorCliente)).then(() => {})
}
